import $ from 'jQuery';
import { downloadJson } from '../machineapp_utils';
import './machine_app_application_view.css';
import { showConfirmationModal } from '../components/machine_app_confirmation_modal';
import { showMessageBox } from '../components/machine_app_toast_message_box';
import { popup } from '../components/machine_app_popup';
import { applicationCard } from '../../views/application_landing_page/application_card_widget';
const machine_app_state = require('../models/machine_app_state');

export function machineAppApplicationLandingPage(pMachineAppLibrary, pOnUpdate, pMachineAppDefinitionName) {
  const lContainer = $('<div>').addClass('machine_app_application_list_container ml_scrollable');
  const lItemContainer = $('<div>').addClass('machine_app_application_list');
  const lOnListChange = () => {
    lRender();
    pOnUpdate();
  };

  const lRender = () => {
    lItemContainer.empty();
    const lNewInstanceItem = applicationCard(
      'icon-add-application',
      'New Instance',
      () => newApp(pMachineAppDefinitionName, pMachineAppLibrary, lOnListChange),
      true
    );
    lItemContainer.append(lNewInstanceItem);

    pMachineAppLibrary.listApplications().forEach(function(pMachineApp) {
      let lLastCard = undefined;
      let lIsRenaming = false;
      const lRenderApp = () => {
        const lHasWarnings = !pMachineApp.getInjectableApplication().validate();
        const lItem = applicationCard(
          'icon-machine-app',
          pMachineApp.getName(),
          () => {
            machine_app_state.getInterface().mMachineLogicLibrary.selectApplicationByName(pMachineApp.getName());
            machine_app_state.getInterface().redirectMachineAppToMachineLogic(pMachineApp.getName());
          },
          false,
          lIsRenaming,
          (pNewName) => {
            if (pNewName) pMachineApp.setName(pNewName);
            lIsRenaming = false;
            lRenderApp();
          },
          lHasWarnings,
          pMachineApp.getInjectableApplication()
        );

        lItem.contextmenu((pEvent) => {
          const lPopup = actionDropdown(
            pMachineApp,
            pMachineAppLibrary,
            () => {
              lIsRenaming = true;
              lRenderApp();
            },
            lOnListChange
          );
          lPopup.show({ top: (pEvent.pageY + 10), left: (pEvent.pageX - 100) });
          pEvent.stopPropagation();
          pEvent.preventDefault();
          $('body').on('click', lPopup.hide);
        });

        if (lLastCard)  {
          lLastCard.replaceWith(lItem);
        }
        else {
          lItemContainer.append(lItem);
        }
        lLastCard = lItem;
      };

      lRenderApp();
    });

  };

  lContainer.append(
    lItemContainer
  );

  lRender();

  return{
    body: lContainer
  };
}

function actionDropdown(pMachineApp,
  pMachineAppLibrary,
  pOnRename,
  pOnListChange
) {
  const lDropDownMenu = popup();

  lDropDownMenu.container
    .addClass('machine_application_dropdown_container')
    .append(
      getDropDownButton(
        'Rename',
        () => {
          pOnRename(pMachineApp);
          lDropDownMenu.hide();
        },
        'icon-edit'
      ),
      getDropDownButton(
        'Duplicate',
        () => {
          duplicateApp(pMachineApp, pMachineAppLibrary, pOnListChange);
          lDropDownMenu.hide();
        },
        'icon-copy'
      ),
      getDropDownButton(
        'Download',
        () =>  {
          downloadJson(
            `${pMachineApp.getName()}.json`,
            JSON.stringify({
              application: pMachineApp.toJson(),
              palletParameters: pMachineAppLibrary.listConfigurations().map(function(pConfiguraton) { return pConfiguraton.toJson(); }),
              machineParameters: pMachineAppLibrary.listMachineParameters().map(function(pParameter) { return pParameter.toJson(); }),
            }, null, 2),
          );
          lDropDownMenu.hide();
        },
        'icon-arrowdown'
      ),
      $('<hr>')
        .addClass('machineapp_application_dropdown_divider'),
      getDropDownButton(
        'Delete',
        () =>  {
          removeApp(pMachineApp, pMachineAppLibrary, pOnListChange);
          lDropDownMenu.hide();
        },
        'icon-delete'
      ).addClass('machineapp_application_dropdown_delete')
    );

  return lDropDownMenu;
}

function getDropDownButton(pButtontext, pOnClick, pIconClass) {
  return $('<button>')
    .addClass('machineapp_application_dropdown_button')
    .append(pIconClass ? $('<i>').addClass(pIconClass) : '')
    .append($('<span>').text(pButtontext))
    .on('click', () => {
      pOnClick();
    });
}


function getAppName(pMachineAppDefinitionName, pMachineAppLibrary) {
  return `${pMachineAppDefinitionName} #${(pMachineAppLibrary.listApplications().length + 1)}`;
}

function newApp(pMachineAppDefinitionName, pMachineAppLibrary, pOnSuccess) {
  const lOnError = function() {
    showMessageBox('Failed to create the application', 'error');
  };
  pMachineAppLibrary.newApplication(getAppName(pMachineAppDefinitionName, pMachineAppLibrary), pOnSuccess, lOnError);
}

function duplicateApp(pItem, pMachineAppLibrary, pOnSuccess) {
  const lOnSuccess = function(pNewItem) {
    pOnSuccess(pNewItem);
    pNewItem.setName(pItem.getName());
  };
  const lOnError = function() {
    showMessageBox('Failed to duplicate the application', 'error');
  };
  pMachineAppLibrary.duplicateItem(pItem, lOnSuccess, lOnError);
}

function removeApp(pItem, pMachineAppLibrary, pOnSuccess) {
  showConfirmationModal({
    pTitle: 'Are you sure that you want to delete?',
    pSubTitle: 'Are you sure you want to delete this MachineApp?',
    pOnCancel: function() { },
    pOnConfirm: function() {
      const lOnSuccess = pOnSuccess;
      const lOnError = function() {
        showMessageBox('Failed to delete the application', 'error');
      };

      pMachineAppLibrary.removeApplication(pItem.getUuid(), lOnSuccess, lOnError);
    },
    pCancelText: 'Cancel',
    pConfirmText: 'Delete'
  });
}
